import { Typography } from "@material-ui/core";
import * as React from "react";
import PropTypes from "prop-types";

const SectionTitle = props => {
  return (
    <Typography variant={props.variant} color={props.color} align={props.align} gutterBottom>
      {props.isUpper ? props?.label?.toUpperCase?.() : props?.label}
    </Typography>
  );
};

SectionTitle.propTypes = {
  label: PropTypes.string,
  align: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
  isUpper: PropTypes.bool,
};

SectionTitle.defaultProps = {
  variant: "h6",
  isUpper: false,
};
export default SectionTitle;
